import { Nilable } from "../shared/utils/Nullable";

export interface IBigmlModelDTO {
    id: Nilable<number>;
    status: Nilable<string>;
    message: Nilable<string>;
    models_sent_to_predict: Nilable<number>;
    models_predicted: Nilable<number>;
}

export class BigmlModelDTO {
    public id = 0;
    public status = "";
    public message = "";
    public modelosEnviadosAEntrenar = 0;
    public modelosPredichos = 0;

    constructor(json: Nilable<Partial<IBigmlModelDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlModelDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.status != null) {
            this.status = json.status;
        }
        if (json.message != null) {
            this.message = json.message;
        }
        if (json.models_sent_to_predict != null) {
            this.modelosEnviadosAEntrenar = json.models_sent_to_predict;
        }
        if (json.models_predicted != null) {
            this.modelosPredichos = json.models_predicted;
        }
    }

    public toJson(): IBigmlModelDTO {
        return {
            id: this.id,
            status: this.status,
            models_sent_to_predict: this.modelosEnviadosAEntrenar,
            models_predicted: this.modelosPredichos,
            message: this.message
        };
    }
}
